<template lang="pug">
  .home
    img(src="../assets/default_gift.png")
    button.button.is-primary(@click="gotToMyList") Los geht's!
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/WhishLists.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  },
  methods: {
    gotToMyList () {
      this.axios.post('/users/create-user-and-list/').then(response => {
        this.$store.commit('login', response.data.token)
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.home
  justify-content: center
  align-items: center
  display: flex
  height: 100%
  flex-direction: column

</style>
